import { PayloadAction } from "@reduxjs/toolkit";
import { LayoutState } from "../layout.slice.ts";
import { SubmitIbanPayload } from "../../../actions/submit-iban.action.ts";

export function submitIbanReducer(
  state: LayoutState,
  action: PayloadAction<SubmitIbanPayload>,
) {
  state.isLoading = action.payload.isIbanValid;
}
